import { Typography } from '@mui/material'
import { FC } from 'react'
import { useCountdownTimer } from '../../../../hooks/useCountdownTimer'

type Props = {
    estFinishAt?: string | null
}

export const AnswerPreparationTimer: FC<Props> = ({ estFinishAt }) => {
    const { timer } = useCountdownTimer(estFinishAt ?? new Date().toISOString())
    const time =
        timer.minutes === 0 ? `${timer.seconds} сек` : `${timer.minutes} мин ${timer.seconds} сек`
    return (
        <Typography
            variant="caption2"
            sx={{
                color: '#9195A1',
            }}>
            {timer.seconds === 0 && timer.minutes === 0
                ? 'Еще немного и будет готово...'
                : `Осталось примерно: ${time}`}
        </Typography>
    )
}
